import React from 'react';
import styled, { keyframes } from 'styled-components';

interface ILoadingType {
	size_type?: 'large' | 'small';
	color_type: 'white' | 'black' | 'gray';
}

const CoreLoading = ({ size_type = 'large', color_type }: ILoadingType) => {
	return <LoadingBox size_type={size_type} color_type={color_type} />;
};

const button_loading_spinner = keyframes`
	
	from {
	  transform: rotate(0turn);
	}
  
	to {
	  transform: rotate(1turn);
	}
  
`;

const LoadingBox = styled.div<{
	size_type: 'large' | 'small';
	color_type: 'white' | 'black' | 'gray';
}>`
	--size: ${({ size_type }) => (size_type === 'large' ? '24px' : '16px')};

	width: var(--size);
	height: var(--size);
	position: relative;

	--color: ${({ theme, color_type }) => {
		const color_value: Record<string, 'gray_white' | 'gray80_text' | 'gray30'> = {
			white: 'gray_white',
			black: 'gray80_text',
			gray: 'gray30',
		};

		return theme.colors.gray[color_value[color_type]];
	}};

	&::after {
		content: '';
		position: absolute;
		width: var(--size);
		height: var(--size);
		top: 0;
		left: 0;
		margin: auto;
		border: 2px solid transparent;
		border-top-color: var(--color);
		border-radius: 50%;
		animation: ${button_loading_spinner} 1s ease infinite;
	}
`;

export default CoreLoading;
